import toast from 'react-hot-toast';
import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';
import { setModules } from './userSlice';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureModules: builder.query({
      query: () => `${ENDPOINTS.PERMISSIONS.GET_MODULES}`,
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          dispatch(setModules(data?.data));
        }
      },
    }),
    getUserPermissions: builder.query({
      query: (empCode) => `${ENDPOINTS.PERMISSIONS.GET_USER_PERMISSIONS}${empCode}`,
      providesTags: (result, error, empCode) => [{ type: 'Permission', id: empCode }],
    }),
    setUserPermissions: builder.mutation({
      query: (body) => ({
        url: `${ENDPOINTS.PERMISSIONS.SET_USERS_PERMISSIONS}`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: ['Permission'],
      async onQueryStarted(args, { queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          toast.success('Permission granted successfully!');
        }
      },
    }),
    revokeUserPermissions: builder.mutation({
      query: (body) => ({
        url: `${ENDPOINTS.PERMISSIONS.REVOKE_USERS_PERMISSIONS}`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: ['Permission'],
      async onQueryStarted(args, { queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          toast.success('Permission granted successfully!');
        }
      },
    }),
    setSingleUserPermissions: builder.mutation({
      query: (body) => ({
        url: `${ENDPOINTS.PERMISSIONS.SET_SINGLE_USER_PERMISSIONS}`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: (result, error, { empCode }) => [{ type: 'Permission', id: empCode }],
      async onQueryStarted(args, { queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          toast.success('Permission granted successfully!');
        }
      },
    }),
    revokeSingleUserPermissions: builder.mutation({
      query: (body) => ({
        url: `${ENDPOINTS.PERMISSIONS.REVOKE_SINGLE_USER_PERMISSIONS}`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: (result, error, { empCode }) => [{ type: 'Permission', id: empCode }],
      async onQueryStarted(args, { queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          toast.success('Permission revoked successfully!');
        }
      },
    })
  }),
});

export const {
  useGetFeatureModulesQuery,
  useGetUserPermissionsQuery,
  useSetUserPermissionsMutation,
  useRevokeUserPermissionsMutation,
  useSetSingleUserPermissionsMutation,
  useRevokeSingleUserPermissionsMutation
} = userApiSlice;
